import Vue from "vue/dist/vue.common";
import "./Store/index"

import ProductCarousel from "./Components/ProductCarousel.vue"
import ProductTable from "./Components/ProductTable.vue"
import GoogleMap from "./Components/GoogleMap.vue"

const vueComponents = [
  {
    el: '.vue--locations-map',
    components: {
      'google-map': GoogleMap
    }
  },
  {
    el: '.vue--product-carousel',
    components: {
      'product-carousel': ProductCarousel
    }
  },
  {
    el: '.single_variation_wrap',
    components: {
      'product-table': ProductTable
    }
  }
]

vueComponents.forEach(component => {
  if (document.querySelectorAll(component.el).length > 0) {
    document.querySelectorAll(component.el).forEach(() => {
      new Vue(component)
    })
  }
})
